var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useTheme } from "@fluentui/react";
export var hashimukhThemes = {
    light: {
        semanticColors: {
            textHeaderTitleForeground: '#FFFFFF',
            textHeaderSubtitleForeground: '#FFFFFF',
        }
    },
    dark: {
        palette: {
            themePrimary: '#404040',
            themeLighterAlt: '#060606',
            themeLighter: '#171717',
            themeLight: '#2c2c2c',
            themeTertiary: '#575757',
            themeSecondary: '#808080',
            themeDarkAlt: '#9c9c9c',
            themeDark: '#acacac',
            themeDarker: '#c2c2c2',
            neutralLighterAlt: '#2b2b2b',
            neutralLighter: '#333333',
            neutralLight: '#414141',
            neutralQuaternaryAlt: '#4a4a4a',
            neutralQuaternary: '#515151',
            neutralTertiaryAlt: '#6f6f6f',
            neutralTertiary: '#a2a2a2',
            neutralSecondary: '#888888',
            neutralPrimaryAlt: '#6d6d6d',
            neutralPrimary: '#f1f1f1',
            neutralDark: '#383838',
            black: '#1d1d1d',
            white: '#212121',
        },
        semanticColors: {
            buttonBorder: '#333333',
            buttonTextHovered: '#e1e1e1',
            buttonTextPressed: '#e1e1e1',
            buttonTextChecked: '#C8C8C8',
            buttonTextCheckedHovered: '#acacac',
            link: '#acacac',
            linkHovered: '#c8c8c8',
            progressIndicatorElapsed: '#868686',
        }
    }
};
export var useHashimukhTheme = function () {
    var theme = useTheme();
    var semanticColors = theme.semanticColors, rest = __rest(theme, ["semanticColors"]);
    return __assign({ semanticColors: __assign({ progressIndicatorElapsed: theme.palette.themePrimary, progressIndicatorRemaining: '#868686', textHeaderTitleForeground: theme.palette.white, textHeaderSubtitleForeground: theme.semanticColors.bodyText }, semanticColors) }, rest);
};
//# sourceMappingURL=useHashimukhTheme.js.map